<template>
  <div>
    <p class="text-uppercase text-underline font-bold resume-mb-0 resume-ml-0-25 mt-2">
      DADOS DO CONTRATO (SERVIÇO TELEFÔNICO FIXO COMUTADO – STFC)
    </p>
    <div class="my-1 mt-2" v-if="!isCorporativo">
      <input
        type="checkbox"
        name="juridica"
        value="sFidelização"
        :checked="!extraResume"
        v-if="service.loyalty !== null && !extraResume"
        onclick="return false;"
      />
      <label for="sFidelização" v-if="service.loyalty !== null && !extraResume">
        Sem Fidelização
      </label>

      <input
        type="checkbox"
        name="juridica"
        value="cFidelização"
        :checked="extraResume"
        v-if="extraResume"
        onclick="return false;"
      />
      <label for="cFidelização" v-if="extraResume"> Com Fidelização </label>

      <input
        type="checkbox"
        name="juridica"
        value="plan"
        :checked="service.planLoyalty"
        v-if="service.planLoyalty"
        onclick="return false;"
      />
      <label for="plan" v-if="service.planLoyalty"> Plano</label>
      <input
        type="checkbox"
        name="device"
        :checked="service.telephoneLoayalty"
        v-if="service.telephoneLoayalty"
        onclick="return false;"
      />
      <label for="device" v-if="service.telephoneLoayalty"> Aparelho/Acessórios</label>
    </div>

    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld label="Nº Protocolo Atendimento" :text="service.protocolNumber + ''" />
      <ResumeFieldOld label="Nº Tel (GSM)" :text="service.phone" />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld label="ICCID/TIM Chip" :text="service.iccid" />
      <ResumeFieldOld label="Plano Contratado" :text="service.plan.name" />
    </ResumeFieldGroupOld>

    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld label="Valor Plano Contratado *" :text="service.plan.planValue" />
      <ResumeFieldOld
        v-if="extraResume"
        label="Valor do Plano Contratado com Desconto"
        :text="service.plan.promotionalValue"
      />
    </ResumeFieldGroupOld>

    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld label="Pacote de Dados" :text="service.plan.dataPackage" />
      <ResumeFieldOld
        label="Serviços Adicionais"
        :text="service.additionalServices"
        v-if="service.additionalServices"
      />
      <ResumeFieldOld
        label="Valor Serviço Adicional *"
        :text="service.additionalPrice"
        v-if="service.additionalServices"
      />
    </ResumeFieldGroupOld>

    <ResumeFieldGroupOld class="mt-1" v-if="service.portability.hasPortability">
      <ResumeFieldOld
        label="Portabilidade: Nº a ser portado"
        :text="service.portability.portabilityPhone"
      />
      <ResumeFieldOld
        label="Nº Protocolo de Portabilidade"
        :text="service.portability.portabilityProtocol"
      />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld class="mt-1" v-if="service.portability.hasPortability">
      <ResumeFieldOld label="Data/Hora agendada" :text="dateHour" />
    </ResumeFieldGroupOld>
  </div>
</template>

<script>
import { formatBRDate } from 'utils';

export default {
  name: 'ResumeSTFC',
  props: {
    service: {},
    caption: {
      type: String,
      default: ''
    },
    corporativo: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ResumeFieldOld: () => import('./ResumeFieldOld.vue'),
    ResumeFieldGroupOld: () => import('./ResumeFieldGroupOld.vue')
  },

  computed: {
    extraResume() {
      return this.service.loyalty;
    },
    getCaption() {
      return this.caption;
    },
    isCorporativo() {
      return this.corporativo;
    },
    dateHour() {
      if (this.service.portability.hasPortability) {
        return `${this.formatDate(this.service.portability.schedulingDate)}  ${
          this.service.portability.portabilityHour
        }`;
      }
      return '';
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return formatBRDate(date);
    }
  }
};
</script>
<style lang="scss">
td {
  line-height: 1.4;
}
.print-show {
  display: none;
}
@media print {
  .container-breadcrumb {
    display: none;
  }
}

.titular-container > .titular-dependent .resume-page-title {
  display: none;
}

.titular-container,
.titular-dependent {
  .plan-col {
    width: 24em;
    margin: 10px;
  }
  .screen-hide {
    display: none;
  }
  .screen-footer {
    margin: -1px;
    .sign {
      width: 100%;
    }
  }
  @media print {
    .extraResume {
      margin-top: 20em;
    }
    .plan-col {
      width: 24em;
    }
    .footer {
      margin: -1px;
      .sign {
        width: 100%;
        margin: 2.5em;
      }
    }
    @page {
      margin: 2mm !important;
      margin-bottom: 30mm !important;
    }
    .pagebreak {
      page-break-before: always;
    }
    thead {
      display: table-header-group;
    }
    tfoot {
      display: table-footer-group;
    }
    .screen-hide {
      display: block;
    }
    .print-hidden {
      display: none;
    }
    body > * {
      color: black !important;
    }
    .smart__title,
    .termo-familia-index > div {
      display: none;
    }
    .container {
      max-width: 100;
      margin: 0px;
      padding: 0px;
      width: 100%;
    }
    .smart-card {
      box-shadow: none;
      border: none;
    }
    .relative {
      position: static !important;
    }
    .border-default {
      border: none;
    }
    .ml-5 {
      margin-left: 0.8em !important;
    }
    .mr-5 {
      margin-right: 0.8em !important;
    }
    .sign > div {
      width: 100%;
    }
    .empty-input-hg {
      width: 18em !important;
    }
    .empty-input {
      width: 9.45em !important;
    }
    .mt-3 {
      margin-top: 0.5em !important;
    }
    .signature-second-col {
      margin-left: 6.5em !important;
    }
    .navigator {
      display: none;
    }
  }
  .text-underline {
    text-decoration: underline;
  }
  span {
    text-decoration: none;
  }
  .without-underline {
    text-decoration: none;
  }
  .text-regular {
    text-decoration: none;
  }
  label {
    margin-right: 13px;
    line-height: 1.2rem;
  }
  input[type='radio'] {
    margin-left: 13px;
  }
  .resume-border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .empty-input,
  .empty-input-hg,
  .empty-input-small,
  .empty-input-xhg,
  .signature {
    pointer-events: none;
    border: none;
    border-bottom: 1px solid black;
  }
  .empty-input {
    width: 10em;
  }
  .empty-input-hg {
    width: 20em;
  }
  .empty-input-small {
    width: 3em;
  }
  .empty-input-xhg {
    width: 40em;
  }
  .signature {
    width: 22em;
  }
  .sign {
    display: flex;
    justify-content: center;
  }
  .signature-second-col {
    margin-left: 10em;
    min-width: 10em;
  }
  .signature-first-col {
    min-width: 10em;
  }
}
</style>
